import { observer } from 'mobx-react-lite';
import { FC, useEffect, useRef } from 'react';

import { CallBlurType } from '@gem/call/constants';
import { IcBlockIcon, IcProfileIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { getMascotImageSrc } from '@gem/utils';

import { BackgroundItem } from '../BackgroundItem/BackgroundItem';
import { BackgroundPanelHeader } from '../BackgroundPanelHeader/BackgroundPanelHeader';
import styles from './BackgroundPanel.styles.m.css';

interface IBackgroundPanelProps {
  hasVideo: boolean;
  mediaStream: MediaStream | null;
  blurType: CallBlurType;
  onBlurClick(blurType: CallBlurType): void;
  onClose(): void;
}

export const BackgroundPanel: FC<IBackgroundPanelProps> = observer((props) => {
  const { t } = useTranslation();
  const video = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (video.current && props.hasVideo) {
      video.current.srcObject = props.mediaStream;

      video.current.onloadedmetadata = (): void => {
        video.current?.play();
      };
    }
  }, [props.mediaStream, props.blurType, props.hasVideo]);

  return (
    <div className={styles.container}>
      <BackgroundPanelHeader onClose={props.onClose} />
      <div className={styles.content}>
        {props.hasVideo && (
          <video
            ref={video}
            className={styles.video}
          />
        )}
        <div className={styles.blurBlock}>
          <h3 className={styles.blurTitle}>{t('call_no_effects_and_blur')}</h3>
          <div className={styles.blurList}>
            <BackgroundItem
              icon={IcBlockIcon}
              isActive={props.blurType === CallBlurType.None}
              onClick={props.onBlurClick}
              blurType={CallBlurType.None}
            />
            <BackgroundItem
              icon={IcProfileIcon}
              isActive={props.blurType === CallBlurType.Small}
              background={getMascotImageSrc('blur-image-1.png')}
              onClick={props.onBlurClick}
              blurType={CallBlurType.Small}
            />
            <BackgroundItem
              icon={IcProfileIcon}
              isActive={props.blurType === CallBlurType.Large}
              background={getMascotImageSrc('blur-image-2.png')}
              onClick={props.onBlurClick}
              blurType={CallBlurType.Large}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
